import React, { useState, useContext, useEffect } from "react";
import { ChartOptionsForTierParticpation } from "../../model/ChartOptionsForTierParticpation";
import { InvestmentDTO } from "../../model/investmentDTO";
import { HighChartWrapper } from "../HighChartWrapper/HighChartWrapper";
import TableView from "../TableViewComponent/TableViewComponent";
import { CalculatorInputsDTO } from "../../model/CalculatorInputsDTO";
import { RestartOrEditSettings } from "../CalculatorResults/RestartOrEditSettings";
import { ChartOptionsForCapRate } from "../../model/ChartOptionsForCapRate";
import { ChartOptionsForStepRate } from "../../model/ChartOptionsForStepRate";
import NumberFormat from 'react-number-format';
import { UserInterfaceHints, UserInterfaceHintsContext } from "../Store/UserInterfaceHintsContext";
import { indices, strategyTypes } from "../../model/AvailableInvestmentStrategies";
import { CalculatorResultsContext } from "../Store/CalculatorResultsContext";
import { pipe } from "fp-ts/lib/pipeable";
import { getOrElse } from "fp-ts/lib/Option";

export type ChartData = ChartOptionsForTierParticpation | ChartOptionsForCapRate | ChartOptionsForStepRate | undefined;

interface TabProps {
    chartOptions: ChartData;
    strategyData: InvestmentDTO;
    view: string;
}

export const TabContainer = (props: TabProps) => {

    const hintsContext = useContext(UserInterfaceHintsContext);
    const results = useContext(CalculatorResultsContext);

    const [currentStrategyInputs, setCurrentStrategyInputs] = useState<CalculatorInputsDTO>(props.strategyData?.calculatorInputsDTO);
    useEffect(() => {

        if (props.strategyData && props.strategyData.calculatorInputsDTO && currentStrategyInputs) {
            if (currentStrategyInputs.productCode !== props.strategyData.calculatorInputsDTO.productCode) {
                setCurrentStrategyInputs(props.strategyData.calculatorInputsDTO);
                //setView("chart");
            }
        }
    }, [props.strategyData?.calculatorInputsDTO]);

    useEffect(() => {
        if (props.view === "chart") {
            hintsContext.addHint(UserInterfaceHints.RESULTS_CHART_VIEW);
        } else {
            hintsContext.removeHint(UserInterfaceHints.RESULTS_CHART_VIEW);
        }
    }, [props.view]);


    function strategyNameForCode(code: string) {
        if (strategyTypes.has(code)) {
            const strategyType = strategyTypes.get(code);
            if (strategyType) {
                return strategyType.label;
            } else {
                return code;
            }
        } else {
            return code;
        }
    }

    function indexNameForCode(code: string) {
        if (indices.has(code)) {
            const invIdx = indices.get(code);
            if (invIdx) {
                return invIdx.label;
            } else {
                return code;
            }
        } else {
            return code;
        }
    }


    const strategyTypeName = strategyNameForCode(currentStrategyInputs?.strategyType);

    const termLength = (currentStrategyInputs?.term === 1) ? `${currentStrategyInputs?.term} year` : `${currentStrategyInputs?.term} years`;

    const allocationAmount = (currentStrategyInputs && currentStrategyInputs.allocationAmount)
        ? (<NumberFormat displayType="text" value={currentStrategyInputs.allocationAmount} prefix="$" thousandSeparator="," />)
        : null;

    const indexName = indexNameForCode(currentStrategyInputs?.index);
    
    const shareClass =  pipe(results.config.shareClass, getOrElse(() => ''));



    return (
        < >
            <div className="results-headerline">
                <div className="inputs-summary">
                    <div className="field">
                            <span className="results-headerline-key"> Share Class: </span><span className="results-headerline-value"> {shareClass} </span>
                        </div>
                    <div className="spacer-line"></div>
                    <div className="field">
                        <span className="results-headerline-key"> Strategy type: </span><span className="results-headerline-value"> {strategyTypeName} </span>
                    </div>
                    <div className="spacer-line"></div>
                    <div className="field">
                        <span className="results-headerline-key"> Allocation amount: </span><span className="results-headerline-value"> {allocationAmount} </span>
                    </div>
                    <div className="spacer-line"></div>
                    <div className="field">
                        <span className="results-headerline-key"> Term: </span><span className="results-headerline-value"> {termLength} </span>
                    </div>
                    <div className="spacer-line"></div>
                    <div className="field">
                        <span className="results-headerline-key"> Buffer level: </span><span className="results-headerline-value"> {currentStrategyInputs?.bufferLevel}% </span>
                    </div>
                    <div className="spacer-line"></div>
                    <div className="field">
                        <span className="results-headerline-key"> Index: </span><span className="results-headerline-value" dangerouslySetInnerHTML={{__html: indexName}}></span>
                    </div>
                </div>
            </div>
                <RestartOrEditSettings />

            {
                props.view === "chart" ? <HighChartWrapper options={props.chartOptions} chart1data={props.strategyData} /> :
                    <TableView strategyData={props.strategyData} />
            }
            {/* <ResultsDisplayToggle viewChanged={switchView} view={view}></ResultsDisplayToggle> */}
        </>
    )

}
